export default __webpack_public_path__ + "static/media/lamb.114d4922.png";